// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explanation-modal-container {
  color: black;
  font-size: 14px;
}

.explanation-modal-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 30px;
}

.explanation-modal-separator {
  background-color: #c9c7c7;
  height: 1px;
  margin: 30px 0;
  width: 100%;
}

.explanation-modal-footer {
  font-size: 12px;
  text-align: right;
  width: 100%;
}

.explanation-modal-footer a {
  color: black;
  cursor: pointer;
  text-decoration: underline;
}

.explanation-modal-footer a:hover {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ExplanationBox/ExplanationBox.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".explanation-modal-container {\n  color: black;\n  font-size: 14px;\n}\n\n.explanation-modal-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.explanation-modal-separator {\n  background-color: #c9c7c7;\n  height: 1px;\n  margin: 30px 0;\n  width: 100%;\n}\n\n.explanation-modal-footer {\n  font-size: 12px;\n  text-align: right;\n  width: 100%;\n}\n\n.explanation-modal-footer a {\n  color: black;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.explanation-modal-footer a:hover {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
